module.exports = __webpack_public_path__ + "media/sound.454e4086.mp3";